import {
  Pipe,
  PipeTransform
} from '@angular/core';

/**
 * A pipe to order a given list of objects by a given field of such object type
 */
@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {

  transform(value: any[], order: string = '', column: string = ''): any[] {
    if (!value || order === '' || !order) {
      return value;
    } // no array
    if (value.length <= 1) {
      return value;
    } // array with only one item
    if (!column || column === '') {
      if (order === 'asc') {
        return value.sort();
      } else {
        return value.sort().reverse();
      }
    } // sort 1d array
    return value.slice().sort((a, b) =>
      a[column] < b[column] ?
        (order === 'asc' ? -1 : 1)
        : a[column] > b[column] ?
          (order === 'asc' ? 1 : -1)
          : 0);

  }
}
